import {StockItemLocallyExtended, StockItemUnsafeAdditions} from '../datastructures';

export type StockItemValTypeStr = 'string' | 'number' | 'date' | 'boolean' | 'string[]' | 'null';

export type MissingStockTypes = 'mainSupplier' | 'maxReturned' | 'maxSold' |
  'netSold' | 'negativeDays' | 'outOfStock' | 'priceEdits' | 'qtyDiff' | 'zeroDays';

export const getStockValueType = (
  key: keyof (StockItemUnsafeAdditions & StockItemLocallyExtended) | MissingStockTypes)
  : StockItemValTypeStr => {
  switch (key) {
    case 'alternateDescription':
    case 'barcode':
    case 'binL':
    case 'code':
    case 'dep':
    case 'desc':
    case 'genCode':
    case 'lineColourCode':
    case 'regularSuppCode':
    case 'reportItemCode':
    case 'stockId':
    case 'storeId':
    case 'subDep':
    case 'suppCode':
    case 'suppUsedLast1':
    case 'suppUsedLast2':
    case 'suppUsedLast3':
    case 'suppUsedLast4':
    case 'suppUsedLast5':
    case 'suppUsedLastPrice1':
    case 'suppUsedLastPrice2':
    case 'suppUsedLastPrice3':
    case 'suppUsedLastPrice4':
    case 'suppUsedLastPrice5':
      return 'string';

    case 'avCost':
    case 'category':
    case 'dlvColl':
    case 'gp1':
    case 'latestCost':
    case 'stockValue':
    case 'maxDisc':
    case 'maxReturned':
    case 'maxSold':
    case 'negativeDays':
    case 'netSold':
    case 'nominalGP':
    case 'onHand':
    case 'onHoldCode':
    case 'orderQty':
    case 'ordLvl':
    case 'outOfStock':
    case 'packSize':
    case 'priceEdits':
    case 'prvSellingPri':
    case 'purchaseOrder':
    case 'qtyDiff':
    case 'recommendedGP':
    case 'reportItemFactor':
    case 'salesOrder':
    case 'sellPriExcl1':
    case 'sellPriIncl1':
    case 'sellPrice2':
    case 'sellPriceIncluding2':
    case 'sellPrice3':
    case 'sellPriceIncluding3':
    case 'sellPrice4':
    case 'sellPriceIncluding4':
    case 'sellPrice5':
    case 'sellPriceIncluding5':
    case 'sellPrice6':
    case 'sellPriceIncluding6':
    case 'sellPrice7':
    case 'sellPriceIncluding7':
    case 'sellPrice8':
    case 'sellPriceIncluding8':
    case 'sellPrice9':
    case 'sellPriceIncluding9':
    case 'sellPrice10':
    case 'sellPriceIncluding10':
    case 'unitsYear':
    case 'user':
    case 'vatR':
    case 'zeroDays':
      return 'number';

    case 'suppUsedLastDate5':
    case 'suppUsedLastDate4':
    case 'suppUsedLastDate3':
    case 'suppUsedLastDate2':
    case 'suppUsedLastDate1':
    case 'lastMoved':
    case 'lastSold':
    case 'lastPurchase':
    case 'prvSellingPriDate':
    case 'created':
    case 'lastStockTake':
    case 'modified':
      return 'date';

    case 'discExempt':
    case 'mainSupplier':
    case 'noDecimal':
    case 'web':
    case 'sellUnderCost':
    case 'sellIntoNegative':
      return 'boolean';

    case '_tags':
    case 'multipleBarcodes':
      return 'string[]';

    default:
      return null;
  }
};
